import { Injectable, ErrorHandler } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable({
	providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {
	constructor(private appInsights: AppInsightsService) {
		super();
	}

	handleError(error: Error) {
		this.appInsights.logException(error);
		super.handleError(error);
	}
}
